// MT — Haunted Hollow theme scripts (vanilla JS)

function mtInitReveal() {
  const els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach((el) => el.classList.add('mt-visible'));
    return;
  }
  const obs = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach((el) => obs.observe(el));
}

function mtInitCountdown() {
  const els = document.querySelectorAll('[data-mt-countdown]');
  els.forEach((el) => {
    const fecha = el.getAttribute('data-fecha');
    if (!fecha) return;
    const objetivo = new Date(fecha).getTime();
    const dEl = el.querySelector('[data-mt-cd-d]');
    const hEl = el.querySelector('[data-mt-cd-h]');
    const mEl = el.querySelector('[data-mt-cd-m]');
    const sEl = el.querySelector('[data-mt-cd-s]');
    const label = el.querySelector('[data-mt-cd-label]');

    function tick() {
      const ahora = Date.now();
      let diff = objetivo - ahora;
      if (diff <= 0) {
        if (dEl) dEl.textContent = '00';
        if (hEl) hEl.textContent = '00';
        if (mEl) mEl.textContent = '00';
        if (sEl) sEl.textContent = '00';
        if (label) label.textContent = el.getAttribute('data-texto-fin') || "It's Halloween!";
        return;
      }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      if (dEl) dEl.textContent = String(d).padStart(2, '0');
      if (hEl) hEl.textContent = String(h).padStart(2, '0');
      if (mEl) mEl.textContent = String(m).padStart(2, '0');
      if (sEl) sEl.textContent = String(s).padStart(2, '0');
      requestAnimationFrame(() => setTimeout(tick, 1000));
    }
    tick();
  });
}

function mtInitGaleriaProducto() {
  const galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach((galeria) => {
    const principal = galeria.querySelector('[data-mt-galeria-principal]');
    const minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
    if (!principal || !minis.length) return;
    minis.forEach((mini) => {
      mini.addEventListener('click', () => {
        const src = mini.getAttribute('data-src');
        const srcset = mini.getAttribute('data-srcset');
        if (!src) return;
        principal.src = src;
        if (srcset) principal.srcset = srcset;
        minis.forEach((m) => m.classList.remove('mt-mini--activa'));
        mini.classList.add('mt-mini--activa');
      });
    });
  });
}

function mtInitVariantes() {
  const forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach((form) => {
    const dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    let variantes = [];
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    const inputId = form.querySelector('input[name="id"]');
    const precioEl = form.querySelector('[data-mt-precio]');
    const compareEl = form.querySelector('[data-mt-precio-comparado]');
    const submitBtn = form.querySelector('[data-mt-submit]');
    const opciones = form.querySelectorAll('[data-mt-opcion]');
    const formatoMoneda = form.getAttribute('data-money-format') || '${{amount}}';

    const moneda = (centavos) => {
      const val = (centavos / 100).toFixed(2);
      const sinDecimales = Math.round(centavos / 100).toString();
      return formatoMoneda
        .replace(/\{\{\s*amount\s*\}\}/g, val)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, sinDecimales);
    };

    const actualizar = () => {
      const seleccion = [];
      opciones.forEach((grupo) => {
        const activo = grupo.querySelector('.mt-opcion-valor--activa');
        seleccion.push(activo ? activo.getAttribute('data-valor') : null);
      });
      const variante = variantes.find((v) => v.options.every((val, i) => val === seleccion[i]));
      if (!variante) return;
      if (inputId) inputId.value = variante.id;
      if (precioEl && variante.price != null) precioEl.textContent = moneda(variante.price);
      if (compareEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          compareEl.textContent = moneda(variante.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (submitBtn) {
        if (variante.available) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.getAttribute('data-texto-disponible') || submitBtn.textContent;
        } else {
          submitBtn.disabled = true;
          submitBtn.textContent = submitBtn.getAttribute('data-texto-agotado') || 'Sold out';
        }
      }
    };

    opciones.forEach((grupo) => {
      grupo.querySelectorAll('.mt-opcion-valor').forEach((btn) => {
        btn.addEventListener('click', () => {
          grupo.querySelectorAll('.mt-opcion-valor').forEach((b) => b.classList.remove('mt-opcion-valor--activa'));
          btn.classList.add('mt-opcion-valor--activa');
          actualizar();
        });
      });
    });

    actualizar();
  });
}

function mtInitAddToCart() {
  const formularios = document.querySelectorAll('[data-mt-producto-form] form');
  formularios.forEach((form) => {
    form.addEventListener('submit', (evt) => {
      evt.preventDefault();
      const submitBtn = form.querySelector('[data-mt-submit]');
      if (submitBtn && submitBtn.disabled) return;
      if (submitBtn) submitBtn.disabled = true;

      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const formData = new FormData(form);
      formData.append('sections_url', window.location.pathname);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map((s) => s.id));
      }

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status) {
            if (submitBtn) submitBtn.disabled = false;
            return;
          }
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(data);
            if (typeof cart.open === 'function') cart.open(submitBtn);
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(() => {
          form.submit();
        })
        .finally(() => {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  mtInitReveal();
  mtInitCountdown();
  mtInitGaleriaProducto();
  mtInitVariantes();
  mtInitAddToCart();
});
